import { initSVG } from '../../helpers';
import { initTooltips } from '../../helpers/tooltips';
import { ENDPOINT } from '../../constants';
import 'jquery.dotdotdot';
import VideoModal from 'components/VideoModal';
import ExcerptsModal from 'components/book/ExcerptsModal';
import EmailDisclaimerModal from 'components/EmailDisclaimerModal';
import CookieUseDisclaimer from 'components/global/CookieUseDisclaimer';
import Header from 'components/global/Header';

function global(){
  // Inline SVGs
  initSVG({
    el: 'img.svg',
    target: 'svg'
  });

  initTooltips();

  $('.wh-text-trim').each((index, element) => {
    $(element).dotdotdot({
      watch: 'window'
    })
  });

  // Videos
  if ($('.wh-video-trigger').length) {
    new VideoModal($('.wh-video-trigger'),  {
      template: require('templates/video-modal'),
      autoPlay: true
    });
  }

  if ($('.wh-excerpts-trigger').length) {
    new ExcerptsModal($('.wh-excerpts-trigger'),  {
      template: require('templates/excerpts-modal'),
      endpoint:  ENDPOINT.getExcerpts
    });
  }

  // Email Disclaimer
  new EmailDisclaimerModal($('body'));

  // In the case of the right sticky rail there are 2 .col-30 in the page
  $('.col-30').each((index, element) => {
    if ($(element).children().length === 0) {
      $(element).remove();

    } else {
      // Sticky Right Rail
      // In this case the .wh-sticky__wrapper and col-30--bottom' will always exists, so we check if
      // they don't have any children and if that's the case we remove the entire .col-30
      if ($(element).find('.wh-sticky__wrapper').length && $(element).find('.col-30--bottom')) {
        if ($(element).find('.wh-sticky__wrapper').children().length === 0
          && $(element).find('.col-30--bottom').children().length === 0) {
          $(element).remove();
        }
      }
    }
  });

  new Header('.wh-header', {
    endpoint: ENDPOINT.getHeaderKeywordSearch,
    PredictiveSearch: require('components/global/PredictiveSearch').default,
    triggerElement: $('.wh-home-page-hero__logo')
  });

  new CookieUseDisclaimer('.wh-cookie-use-disclaimer', {
    endpoint: ENDPOINT.setUseDisclaimerCookie
  });

  //Cookie Control
  if (window.localStorage.getItem('whCCDate') === null) {
    window.localStorage.setItem('whCCDate', new Date().getTime());
  }

  if (window.ccUpdatedDate && window.localStorage.getItem('whCCDate') && window.CookieControl) {
    const ccUpdate = new Date(window.ccUpdatedDate);
    const ccSeenDate = new Date(window.localStorage.getItem('whCCDate') * 1)
    if (ccUpdate.getTime() > ccSeenDate.getTime()) {
      window.CookieControl.open();
      window.localStorage.setItem('whCCDate', new Date(window.ccUpdatedDate).getTime());
    }
  }
}

export default global;



// WEBPACK FOOTER //
// ./src/js/components/global/index.js